import type {
  GetOAuthProviderConfigResponse,
  GetUserInfoRequest,
  GetUserInfoResponse,
  LoginForOAuthWebSessionResponse,
  LogoutRequest,
  LogoutResponse,
  SendEmailAuthCodeRequest,
  SendEmailAuthCodeResponse,
  VerifyEmailAuthCodeRequest,
  VerifyEmailAuthCodeResponse,
} from '@/types';
import accountApi from './accountApi';

export const authApi = {
  // 获取当前用户信息（从 cookie 读取 session_id）
  getUserInfo: async (): Promise<GetUserInfoResponse> => {
    return accountApi.post('/user/v1/user_info', {} as GetUserInfoRequest);
  },

  getOAuthProviderConfig: async (
    provider: string,
    appId: string,
  ): Promise<GetOAuthProviderConfigResponse> => {
    return accountApi.get('/auth/v1/oauth_provider_config', {
      params: {
        provider,
        app_id: appId,
      },
    });
  },

  loginForOAuthWebSession: async (request: {
    provider: string;
    code: string;
    redirect_uri: string;
    state: string;
    code_verifier?: string;
    app_id: string;
  }): Promise<LoginForOAuthWebSessionResponse> => {
    return accountApi.post('/auth/v1/login_for_oauth_web_session', request);
  },

  // 发送邮箱验证码
  sendEmailAuthCode: async (
    email: string,
    appId: string,
  ): Promise<SendEmailAuthCodeResponse> => {
    return accountApi.post('/auth/v1/send_auth_code', {
      email,
      app_id: appId,
    } as SendEmailAuthCodeRequest);
  },

  // 验证邮箱验证码
  verifyEmailAuthCode: async (
    email: string,
    code: string,
    appId: string,
  ): Promise<VerifyEmailAuthCodeResponse> => {
    return accountApi.post('/auth/v1/verify_auth_code_for_web_session', {
      email,
      code,
      app_id: appId,
    } as VerifyEmailAuthCodeRequest);
  },

  // 登出
  logout: async (appId: string): Promise<LogoutResponse> => {
    return accountApi.post('/auth/v1/logout_web_session', {
      app_id: appId,
    } as LogoutRequest);
  },
};
